import mod from "../lib/index.js";

export default mod["default"];
export const DropdownControl = mod.DropdownControl;
export const DropdownDivider = mod.DropdownDivider;
export const DropdownHeader = mod.DropdownHeader;
export const DropdownItem = mod.DropdownItem;
